import React from 'react';
import WorkflowOnboard from './WorkflowOnboard';

export default function WorkflowParent({ headerTableData, processType, processWorkflowType }) {
  return (
    <WorkflowOnboard
      headerTableData={headerTableData}
      processType={processType}
      processWorkflowType={processWorkflowType}
    />
  );
}
